'use strict';

var curve = exports;

curve.base = require('./base');
curve.short = require('./short');
curve.mont = require('./mont');
curve.edwards = require('./edwards');



//////////////////
// WEBPACK FOOTER
// ./~/_elliptic@6.5.1@elliptic/lib/elliptic/curve/index.js
// module id = puSd
// module chunks = 0